<div [class]="field.styleValue">
  <span class="d-inline-flex align-items-center text-value">
    <ds-metadata-link-view [item]="item" [metadata]="metadataValue"></ds-metadata-link-view>
  </span>
</div>